<template>
  <div>
    <div slot="title">
      <h2>Detalles del Evaluado</h2>
    </div>
    <div slot="main">
      <div class="container-fluid">
        <div class="row" style="margin-top: 20px">
          <div class="col-2">
            <button type="button" class="form-control" @click="RegresarLista">
              <i class="fa fa-arrow-left"></i
              ><span class="col-form-label" style="margin-left: 50px"
                >Regresar</span
              >
            </button>
          </div>
        </div>
        <div class="row">
          <div class="col-3" style="border-right: solid; padding-right: 20px">
            <div class="row">
              <div class="col-12">
                <h4><span class="col-form-label">Persona Evaluada</span></h4>
              </div>
            </div>
            <div class="row" style="margin-top: 10px; margin-bottom: 10px">
              <div
                class="col-6 d-flex justify-content-center"
                style="overflow: hidden"
              >
                <RostroDePersona
                  :personaId="evaluadoId"
                  :conBotonDeSubidor="false"
                  :conBotonDeDescarga="false"
                  :key="evaluadoId"
                >
                </RostroDePersona>
                <!--<i data-v-6bbe8d3f="" class="fas fa-user-tie prof-pic"></i>-->
              </div>
              <div class="col-12">
                <div class="row">
                  <span class="col-form-label"
                    ><b>Evaluado : </b>{{ nombreEvaluado }}</span
                  >
                </div>
                <div class="row">
                  <span class="col-form-label"
                    ><b>Estatus : </b>{{ estatus }}</span
                  >
                </div>
                <div class="row">
                  <span class="col-form-label"
                    ><b>Sección : </b>{{ seccion }}</span
                  >
                </div>
                <div class="row">
                  <span class="col-form-label"
                    ><b>Departamento : </b>{{ departamento }}</span
                  >
                </div>
                <div class="row">
                  <span class="col-form-label"
                    ><b>Puesto : </b>{{ puesto }}</span
                  >
                </div>
                <div class="row">
                  <span class="col-form-label"
                    ><b>Tipo Puesto : </b>{{ tipoPuesto }}</span
                  >
                </div>
                <div class="row">
                  <span class="col-form-label"
                    ><b>Periodo a Evaluar : </b>{{ periodoEvaluacion }}</span
                  >
                </div>
              </div>
            </div>
          </div>
          <div class="col-9">
            <ul
              class="nav nav-tabs"
              id="tabAltaUsuario"
              role="tablist"
              style="display: none"
            >
              <li class="nav-item">
                <a
                  class="nav-link active"
                  id="general-tab"
                  data-toggle="tab"
                  href="#general"
                  role="tab"
                  aria-controls="general"
                  aria-selected="true"
                  >General</a
                >
              </li>
              <li class="nav-item">
                <a
                  class="nav-link"
                  id="evaluadores-tab"
                  data-toggle="tab"
                  href="#evaluadores"
                  role="tab"
                  aria-controls="evaluadores"
                  aria-selected="false"
                  >Asignación de Evaluadores</a
                >
              </li>
            </ul>
            <div class="tab-content" id="myTabContent">
              <div
                class="tab-pane fade show active"
                id="general"
                role="tabpanel"
                aria-labelledby="general-tab"
              >
                <div class="row">
                  <div class="col-5">
                    <h5>
                      <span class="col-form-label">
                        Evaluadores Asignados
                        <span class="badge badge-light">{{
                          evaluadoresAsignados
                        }}</span>
                      </span>
                    </h5>
                  </div>
                  <div class="col-3"></div>
                  <div class="col-4">
                    <input
                      type="button"
                      class="form-control"
                      value="Asignar Evaluadores"
                      @click="clickPestana('evaluadores-tab')"
                    />
                  </div>
                </div>
                <div class="row">
                  <div class="col-12"><hr /></div>
                </div>
                <div class="row" v-if="!asignadosIniciales">
                  <div class="col-6">
                    <h5>
                      <span class="col-form-label"
                        >Seleccionar Cuestionarios</span
                      >
                    </h5>
                  </div>
                </div>
                <div class="row">
                  <div class="col-12">
                    <div class="row" style="margin-top: 30px">
                      <div class="col-4">
                        <select
                          class="form-control"
                          v-model="idCuestionarios[0]"
                          v-bind:disabled="!cuestionariosRequeridos[0]"
                          id="listaAutoevaluaciones"
                        >
                          <option disabled selected value="0">
                            Cuestionario de Autoevaluación
                          </option>
                        </select>
                      </div>
                      <div class="col-4">
                        <select
                          class="form-control"
                          v-model="idCuestionarios[2]"
                          v-bind:disabled="!cuestionariosRequeridos[2]"
                          id="listaEvaluacionesSuperiores"
                        >
                          <option disabled selected value="0">
                            Cuestionario para Superiores
                          </option>
                        </select>
                      </div>
                    </div>
                    <div class="row" style="margin-top: 30px">
                      <div class="col-4">
                        <select
                          class="form-control"
                          v-model="idCuestionarios[1]"
                          v-bind:disabled="!cuestionariosRequeridos[1]"
                          id="listaEvaluacionesIguales"
                        >
                          <option disabled selected value="0">
                            Cuestionario para Iguales
                          </option>
                        </select>
                      </div>
                      <div class="col-4">
                        <select
                          class="form-control"
                          v-model="idCuestionarios[3]"
                          v-bind:disabled="!cuestionariosRequeridos[3]"
                          id="listaEvaluacionesSubordinados"
                        >
                          <option disabled selected value="0">
                            Cuestionario para Subordinados
                          </option>
                        </select>
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  class="row"
                  style="margin-top: 30px"
                  v-if="asignadosIniciales"
                >
                  <div class="col-12">
                    <table
                      class="table table-striped table-light table-hover"
                      id="tablaEvaluadores2"
                    >
                      <thead class="thead-dark">
                        <tr>
                          <th class="text-center">ID Evaluador</th>
                          <th class="text-center">Nombre de evaluador</th>
                          <th class="text-center">Puesto</th>
                          <th class="text-center">Tipo de Evaluador</th>
                          <th class="text-center">Estatus de evaluación</th>
                          <th class="text-center">Acciones</th>
                        </tr>
                      </thead>
                    </table>
                  </div>
                </div>
                <div class="row" style="margin-top: 100px">
                  <div class="col-8"></div>
                  <div class="col-4">
                    <input
                      type="button"
                      class="form-control"
                      value="Finalizar"
                      v-bind:disabled="deshabilitarBoton"
                      @click="finalizar"
                    />
                  </div>
                </div>
              </div>
              <div
                class="tab-pane fade show"
                id="evaluadores"
                role="tabpanel"
                aria-labelledby="evaluadores-tab"
              >
                <div class="row">
                  <ul
                    class="nav nav-tabs"
                    id="tabAsignarEvaluadores"
                    role="tablist"
                  >
                    <li class="nav-item">
                      <a
                        class="nav-link active"
                        id="eva-tab"
                        data-toggle="tab"
                        href="#eva"
                        role="tab"
                        aria-controls="eva"
                        aria-selected="true"
                        >Evaluadores</a
                      >
                    </li>
                    <li class="nav-item">
                      <a
                        class="nav-link"
                        id="bus-eva-tab"
                        data-toggle="tab"
                        href="#bus-eva"
                        role="tab"
                        aria-controls="bus-eva"
                        aria-selected="false"
                        >Buscar Evaluadores</a
                      >
                    </li>
                    <li class="nav-item">
                      <a
                        class="nav-link"
                        id="eva-prev-tab"
                        data-toggle="tab"
                        href="#eva-prev"
                        role="tab"
                        aria-controls="eva-prev"
                        aria-selected="false"
                        >Evaluadores Previos</a
                      >
                    </li>
                  </ul>
                </div>
                <div class="row" style="margin-top: 20px; min-height: 30vh">
                  <div
                    class="tab-content"
                    id="myTabContent"
                    style="display: flex; width: 100%"
                  >
                    <div
                      class="tab-pane fade show active"
                      id="eva"
                      role="tabpanel"
                      aria-labelledby="eva-tab"
                    >
                      <div class="container-fluid">
                        <div class="row">
                          <div class="col-4">
                            <h5>
                              <span class="col-form-label">Evaluadores</span>
                            </h5>
                          </div>
                        </div>
                        <div class="row">
                          <div class="col-4">
                            <span class="col-form-label">Superiores</span>
                          </div>
                          <div class="col-4">
                            <span class="col-form-label">Iguales</span>
                          </div>
                          <div class="col-4">
                            <span class="col-form-label">Subordinados</span>
                          </div>
                        </div>

                        <div class="row" style="margin-top: 10px">
                          <div class="col-4" id="selectSuperioresDiv"></div>
                          <div class="col-4" id="selectIgualesDiv"></div>
                          <div class="col-4" id="selectSubordinadosDiv"></div>
                        </div>
                        <div class="row" style="margin-top: 10px">
                          <div class="col-2"></div>
                          <div class="col-2">
                            <button
                              type="button"
                              class="form-control"
                              @click="agregarEvaluador(1)"
                            >
                              <span class="col-form-label">Agregar</span
                              ><i
                                class="fa fa-greater-than"
                                style="margin-left: 1vw"
                              ></i>
                            </button>
                          </div>
                          <div class="col-2"></div>
                          <div class="col-2">
                            <button
                              type="button"
                              class="form-control"
                              @click="agregarEvaluador(2)"
                            >
                              <span class="col-form-label">Agregar</span
                              ><i
                                class="fa fa-greater-than"
                                style="margin-left: 1vw"
                              ></i>
                            </button>
                          </div>
                          <div class="col-2"></div>
                          <div class="col-2">
                            <button
                              type="button"
                              class="form-control"
                              @click="agregarEvaluador(3)"
                            >
                              <span class="col-form-label">Agregar</span
                              ><i
                                class="fa fa-greater-than"
                                style="margin-left: 1vw"
                              ></i>
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div
                      class="tab-pane fade"
                      id="bus-eva"
                      role="tabpanel"
                      aria-labelledby="bus-eva-tab"
                    >
                      <div class="container-fluid">
                        <div class="row" style="margin-top: 30px">
                          <div class="col-3">
                            <input
                              type="text"
                              class="form-control"
                              placeholder="Nombre"
                              v-model="nombreBusqueda"
                              v-on:keyup.enter="buscarEvaluadores"
                            />
                          </div>
                          <div class="col-3">
                            <input
                              type="text"
                              class="form-control"
                              placeholder="No. de Nómina"
                              v-model="numeroNominaBusqueda"
                              v-on:keyup.enter="buscarEvaluadores"
                            />
                          </div>
                          <div class="form-group col-3">
                            <C001Area
                              :prefijo="enumeraciones.etiquetasDeHTML.Select"
                              :tipo="enumeraciones.tiposDeSelect.Todas"
                              v-on:valorParaElPadre="cambioAreaHistorialLaboral"
                              :parametros="{}"
                              :valorDefinido="this.datosLocales[0].valor.Id"
                              :key="this.datosLocales[0].valor.Id"
                            ></C001Area>
                          </div>
                          <div class="form-group col-3">
                            <C039TiposDepartamento
                              :prefijo="enumeraciones.etiquetasDeHTML.Select"
                              :tipo="enumeraciones.tiposDeSelect.Seleccione"
                              v-on:valorParaElPadre="
                                cambioTipoDepartamentoLaboral
                              "
                              :valorDefinido="this.datosLocales[1].valor.Id"
                              :hereda="this.datosLocales[0].valor.Id"
                              :key="this.datosLocales[0].valor.Id"
                            ></C039TiposDepartamento>
                          </div>
                        </div>
                        <div class="row">
                          <div class="col-9"></div>
                          <div class="col-3">
                            <input
                              type="button"
                              v-on:click="buscarEvaluadores"
                              value="Buscar"
                              class="form-control"
                            />
                          </div>
                        </div>
                        <div
                          class="row"
                          v-show="mostrarTabla"
                          style="margin-top: 20px"
                        >
                          <div class="col-12">
                            <table
                              class="
                                table table-striped table-light table-hover
                              "
                              id="tablaBusqueda"
                            >
                              <thead class="thead-dark">
                                <tr>
                                  <th>ID Persona</th>
                                  <th>Nombre</th>
                                  <th>Puesto</th>
                                  <th>Area</th>
                                  <th>Tipo Evaluador</th>
                                  <th>Acciones</th>
                                </tr>
                              </thead>
                              <tbody class="text-dark">
                                <tr
                                  v-for="(infoPersona, index) in infoPersonas"
                                  v-bind:key="infoPersona.PersonaId"
                                >
                                  <td>{{ infoPersona.PersonaId }}</td>
                                  <td>{{ infoPersona.NombreCompleto }}</td>
                                  <td>{{ infoPersona.Puesto }}</td>
                                  <td>
                                    {{ infoPersona.Seccion }} -
                                    {{ infoPersona.Departamento }}
                                  </td>
                                  <td>
                                    <select
                                      class="form-control tableSelect"
                                      v-model="tipoEvaluadorBusqueda[index]"
                                    >
                                      <option selected disabled value="0">
                                        Tipo de Evaluador
                                      </option>
                                      <option value="Igual">Igual</option>
                                      <option value="Superior">Superior</option>
                                      <option value="Subordinado">
                                        Subordinado
                                      </option>
                                    </select>
                                  </td>
                                  <td>
                                    <i
                                      v-if="tipoEvaluadorBusqueda[index] != 0"
                                      class="fa fa-plus-circle"
                                      @click="agregarFila($event, infoPersona)"
                                    />
                                  </td>
                                </tr>
                              </tbody>
                            </table>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div
                      class="tab-pane fade"
                      id="eva-prev"
                      role="tabpanel"
                      aria-labelledby="eva-prev"
                    >
                      <div class="container-fluid">
                        <div class="row">
                          <div class="col-4">
                            <h5>
                              <span class="col-form-label"
                                >Evaluadores Previos</span
                              >
                            </h5>
                          </div>
                        </div>
                        <div class="row">
                          <div class="col-4">
                            <span class="col-form-label">Superiores</span>
                          </div>
                          <div class="col-4">
                            <span class="col-form-label">Iguales</span>
                          </div>
                          <div class="col-4">
                            <span class="col-form-label">Subordinados</span>
                          </div>
                        </div>

                        <div class="row" style="margin-top: 10px">
                          <div class="col-4">
                            <select
                              class="form-control"
                              id="selectSuperioresPrevios"
                            >
                              <option
                                v-for="persona in evaluadoresSuperioresAnteriores"
                                v-bind:value="persona.PersonaId"
                                v-bind:key="persona.PersonaId"
                                v-bind:puesto="persona.Puesto"
                                v-bind:seccion="persona.Seccion"
                                v-bind:departamento="persona.Departamento"
                                v-bind:nombre="persona.NombreCompleto"
                              >
                                {{ persona.NombreCompleto }} -
                                {{ persona.Puesto }}
                              </option>
                            </select>
                          </div>
                          <div class="col-4">
                            <select
                              class="form-control"
                              id="selectIgualesPrevios"
                            >
                              <option
                                v-for="persona in evaluadoresIgualesAnteriores"
                                v-bind:value="persona.PersonaId"
                                v-bind:key="persona.PersonaId"
                                v-bind:puesto="persona.Puesto"
                                v-bind:seccion="persona.Seccion"
                                v-bind:departamento="persona.Departamento"
                                v-bind:nombre="persona.NombreCompleto"
                              >
                                {{ persona.NombreCompleto }} -
                                {{ persona.Puesto }}
                              </option>
                            </select>
                          </div>
                          <div class="col-4">
                            <select
                              class="form-control"
                              id="selectSubordinadosPrevios"
                            >
                              <option
                                v-for="persona in evaluadoresSubordinadosAnteriores"
                                v-bind:value="persona.PersonaId"
                                v-bind:key="persona.PersonaId"
                                v-bind:puesto="persona.Puesto"
                                v-bind:seccion="persona.Seccion"
                                v-bind:departamento="persona.Departamento"
                                v-bind:nombre="persona.NombreCompleto"
                              >
                                {{ persona.NombreCompleto }} -
                                {{ persona.Puesto }}
                              </option>
                            </select>
                          </div>
                        </div>
                        <div class="row" style="margin-top: 10px">
                          <div class="col-2"></div>
                          <div class="col-2">
                            <button
                              type="button"
                              class="form-control"
                              @click="agregarEvaluador(4)"
                            >
                              <span class="col-form-label">Agregar</span
                              ><i
                                class="fa fa-greater-than"
                                style="margin-left: 1vw"
                              ></i>
                            </button>
                          </div>
                          <div class="col-2"></div>
                          <div class="col-2">
                            <button
                              type="button"
                              class="form-control"
                              @click="agregarEvaluador(5)"
                            >
                              <span class="col-form-label">Agregar</span
                              ><i
                                class="fa fa-greater-than"
                                style="margin-left: 1vw"
                              ></i>
                            </button>
                          </div>
                          <div class="col-2"></div>
                          <div class="col-2">
                            <button
                              type="button"
                              class="form-control"
                              @click="agregarEvaluador(6)"
                            >
                              <span class="col-form-label">Agregar</span
                              ><i
                                class="fa fa-greater-than"
                                style="margin-left: 1vw"
                              ></i>
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-4">
                    <h5>
                      <span class="col-form-label"
                        >Evaluadores Seleccionados</span
                      >
                    </h5>
                  </div>
                </div>
                <div class="row">
                  <div class="col-12">
                    <table
                      class="table table-striped table-light table-hover"
                      id="tablaEvaluadores"
                    >
                      <thead class="thead-dark">
                        <tr>
                          <th>ID Persona</th>
                          <th>Nombre del Evaluador</th>
                          <th>Puesto</th>
                          <th>Tipo Evaluador</th>
                          <th>Acciones</th>
                        </tr>
                      </thead>
                      <tbody class="text-dark">
                        <tr
                          v-for="evaluador in nuevosEvaluadores"
                          v-bind:key="evaluador.PersonaId"
                        >
                          <td>{{ evaluador.PersonaId }}</td>
                          <td>{{ evaluador.NombreCompleto }}</td>
                          <td>
                            {{ evaluador.Puesto }} - {{ evaluador.Seccion }}
                          </td>
                          <td>
                            {{ evaluador.TipoEvaluador }}
                          </td>
                          <td>
                            <i
                              class="fa fa-trash"
                              @click="borrarFila(evaluador)"
                            />
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
                <div class="row">
                  <div class="col-8"></div>
                  <div class="col-2">
                    <input
                      type="button"
                      class="form-control"
                      value="Cancelar"
                      @click="cancelar"
                    />
                  </div>
                  <div class="col-2">
                    <input
                      type="button"
                      class="form-control"
                      value="Guardar"
                      v-bind:disabled="
                        nuevosEvaluadores.length <= 0 || asignadosIniciales
                      "
                      @click="guardarEvaluadores"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import comun from "@/../static/js/comun";
import enumeraciones from "@/../static/js/enumeraciones";
import api from "@/../static/js/api";
import axios from "axios";
import Vue from "vue";
import store from "@/store/index";
import catalogos from "@/../static/js/catalogos";

export default {
  props: ["idEvaluacion"], //Recibe como parametro el id de evaluación
  data() {
    return this.datosIniciales();
  },
  components: {
    RostroDePersona: catalogos.SIAP.RostroDePersona,
    C001Area: catalogos.PJ.C001Area,
    C039TiposDepartamento: catalogos.PJ.C039TipoDepartamento,
  },
  methods: {
    datosIniciales() {
      return {
        //asigna los valores iniciales del data
        enumeraciones,
        idCuestionarios: ["0", "0", "0", "0"], //Contiene los valores de los select de cuestionarios
        cuestionariosRequeridos: [false, false, false, false], //Indica si el tipo de cuestionario es requerido
        nombreEvaluado: "", //Almacena el nombre del evaluado
        estatus: "Desconocido", //Almacena el estatusde la evaluación
        seccion: "", //Almacena la sección del evaluado
        departamento: "", //Almacena el departamento del evaluado
        puesto: "", //Almacena el puesto del evaluado
        tipoPuesto: "", //Almacena el tipo de contrato del evaluado
        periodoEvaluacion: "", //Almacena el periodo de evaluación
        evaluadoresAsignados: 0, //Almacena la cantidad de evaluadores asignados
        filtroPuesto: false, //Determina si el filtro de puesto está activado para la busqueda de evaluadores
        mostrarTabla: false, //Determina si la tabla de busqueda de evaluadores es visible
        numeroFilas: 1, //Almacena la cantidad de filas que hay en la tabla de evaluadores
        nombreBusqueda: "", //Guarda el valor de nombre para el filtro de busqueda de evaluadores
        numeroNominaBusqueda: null, //Guarda el valor de numero de nomina para el filtro de busqueda de evaluadores
        interinoBusqueda: false, //Guarda el valor de contrato interino para el filtro de busqueda de evaluadores
        deBaseBusqueda: false, //Guarda el valor de contrato de base para el filtro de busqueda de evaluadores
        filtroPuesto: false, //Guarda el valor de tipo de puesto para el filtro de busqueda de evaluadores
        baneados: [], //Guarda el id de personas no consideradas para la busqueda de evaluadores (repetidos, el mismo evaluado)
        evaluadores: [], //Guarda la información de los evaluadores asignados
        evaluadoId: 0, //Guarda el id del evaluado
        asignadosIniciales: false,
        fechaInicio: null,
        fechaFin: null,
        periodoLaboralEvaluado: null,
        infoPersonas: [],
        tipoEvaluadorBusqueda: [],
        nuevosEvaluadores: [],
        evaluadoresSuperioresAnteriores: [],
        evaluadoresIgualesAnteriores: [],
        evaluadoresSubordinadosAnteriores: [],
        datosLocales: [
        {
          Id: 0,
          key: "Area_TabLaborales",
          valor: {
            Id: 0,
            nombre: null
          }
        },
        {
          Id: 1,
          key: "Departamento_TabLaborales",
          valor: {
            Id: -1,
            nombre: null
          }
        }
      ]
      };
    },
    cargarDatosEvaluacion: function () {
      //Hace la petición para recibir los datos generales sobre la evaluación a mostrar
      //Carga los datos para hacer la peticion
      var peticion = {
        esPrueba: false,
        idEvaluacion: this.idEvaluacion,
      };
      axios
        .post(api.conexion + api.SISEVA.funcion.GetEvaluacion, peticion)
        .then((response) => {
          if (response.data.SiHayError == false) {
            var evaluacion = response.data.evaluacion;
            this.estatus = evaluacion.Estatus;
            var evaluadores = response.data.evaluacion.evaluadores;
            this.asignadosIniciales = evaluadores.length > 0;
            if (this.asignadosIniciales) {
              this.buscarEvaluadoresAsignados();
            }
            var cuestionariosRequeridos = this.cuestionariosRequeridos;
            var baneados = this.baneados;
            var agregarFilaInicio = this.agregarFilaInicio;
            this.nombreEvaluado = evaluacion.nombreEvaluado;
            this.seccion = evaluacion.Seccion;
            this.departamento = evaluacion.Departamento;
            this.puesto = evaluacion.Puesto;
            this.tipoPuesto = evaluacion.TipoPlaza;
            this.periodoEvaluacion =
              evaluacion.FechaInicioPeriodoEvaluacionString +
              " - " +
              evaluacion.FechaFinPeriodoEvaluacionString;
            this.evaluadoresAsignados = evaluacion.noCuestionarios;
            this.fechaInicio = evaluacion.FechaInicioPeriodoEvaluacion;
            this.fechaFin = evaluacion.FechaFinPeriodoEvaluacion;
            this.periodoLaboralEvaluado = evaluacion.periodoLaboralEvaluado;
            baneados.push(evaluacion.EvaluadoId);
            this.evaluadoId = evaluacion.EvaluadoId; //Extrae los resultados de la petición pára insertarlos en la vista
            var infoPersona = {
              EvaluadorId: 0,
              NombreCompleto: "",
              Puesto: "",
              TipoEvaluador: "",
            }; //Construye el objeto infoPersona
            evaluadores.forEach(function (evaluador) {
              //Itera a través de los evaluadores asignados retornados por la petición
              cuestionariosRequeridos[evaluador.TipoEvaluadorId - 1] = true; //actualiza el valor de cuestionariosRequeridos en base al tipo de evaluador
              baneados.push(evaluador.EvaluadorId); //Agrega el id del evaluador a la lista de "excluidos"
              infoPersona.EvaluadorId = evaluador.EvaluadorId;
              infoPersona.NombreCompleto = evaluador.Evaluador.NombreCompleto;
              infoPersona.Puesto = evaluador.Evaluador.Puesto;
              infoPersona.TipoEvaluador = evaluador.TipoEvaluador; //Carga los valores de infoPersona
              agregarFilaInicio(infoPersona); //Agrega al evaluador a la tabla de evaluadores
            });
            this.cuestionariosRequeridos = cuestionariosRequeridos; //Actualiza los cuestionariosRequeridos
            this.baneados = baneados; //Actualiza la lista de "excluidos" para la busqueda de evaluadores
            this.cargarColaboradores();
          } else {
            console.error(response);
            comun.mensajeDeAlerta(response.data.Error.Mensaje, null, null);
          }
        })
        .catch((e) => {
          console.error("encontre un error " + e);
          comun.mensajeDeAlerta(
            comun.mensajeDeError(enumeraciones.error.E500),
            null,
            null
          );
        });
    },
    cargarCuestionarios: function () {
      //Obtiene el listado de cuestionarios por categorías
      //Carga los datos necesarios para hacer la petición
      var peticion = {
        esPrueba: false,
      };
      axios
        .post(
          api.conexion + api.SISEVA.funcion.GetCuestionariosClasificados,
          peticion
        )
        .then((response) => {
          //alert('hola')
          if (response.data.SiHayError == false) {
            //En caso de recibir una respuesta exitosa
            var autoevaluaciones = response.data.Autoevaluaciones;
            var evaluacionesSuperiores = response.data.EvaluacionSuperiores;
            var evaluacionesIguales = response.data.EvaluacionIguales;
            var evaluacionesSubordinados = response.data.EvaluacionSubordinados; //Carga los resultados de la petición en listas
            var o;
            autoevaluaciones.forEach(function (evaluacion) {
              //Itera a través de la lista de autoevaluaciones
              o = new Option(
                evaluacion.nombreCuestionario,
                evaluacion.idFormatoCuestionario
              );
              $(o).html(evaluacion.nombreCuestionario); //Crea un nuevo elemento option con los valores de los cuestionarios
              $("#listaAutoevaluaciones").append(o); //Agrega el cuestionario al select de Autoevaluaciones
            });
            evaluacionesSuperiores.forEach(function (evaluacion) {
              //Itera a través de la lista de evaluaciones de superiores
              o = new Option(
                evaluacion.nombreCuestionario,
                evaluacion.idFormatoCuestionario
              );
              $(o).html(evaluacion.nombreCuestionario);
              $("#listaEvaluacionesSuperiores").append(o);
            });
            evaluacionesIguales.forEach(function (evaluacion) {
              //Itera a través de la lista de evaluaciones de iguales
              o = new Option(
                evaluacion.nombreCuestionario,
                evaluacion.idFormatoCuestionario
              );
              $(o).html(evaluacion.nombreCuestionario);
              $("#listaEvaluacionesIguales").append(o);
            });
            evaluacionesSubordinados.forEach(function (evaluacion) {
              //Itera a través de la lista de evaluaciones a subordinados
              o = new Option(
                evaluacion.nombreCuestionario,
                evaluacion.idFormatoCuestionario
              );
              $(o).html(evaluacion.nombreCuestionario);
              $("#listaEvaluacionesSubordinados").append(o);
            });
          } else {
            console.error(response);
            comun.mensajeDeAlerta(response.data.Error.Mensaje, null, null);
            // this.error = response.data.Error.Mensaje;
            // $('#modalInvalidezAlerta').modal('show');
          }
        })
        .catch((e) => {
          console.error("encontre un error " + e);
          comun.mensajeDeAlerta(
            comun.mensajeDeError(enumeraciones.error.E500),
            null,
            null
          );
        });
    },
    buscarEvaluadores: function () {
      //Retorna una lista de posibles evaluadores filtrados por ciertos criterios
      //Carga los valores para realizar la petición
      var peticion = {
        esPrueba: false,
        nombreBusqueda: this.nombreBusqueda,
        numeroNominaBusqueda: parseInt(this.numeroNominaBusqueda, 10),
        tipoPuestoBusqueda: this.filtroPuesto,
        interinoBusqueda: this.interinoBusqueda,
        deBaseBusqueda: this.deBaseBusqueda,
        baneados: this.baneados,
        AreaId: this.datosLocales[0].valor.Id,
        DepartamentoId: this.datosLocales[1].valor.Id,
      };
      console.log(peticion);
      comun.SeEstaCargandoInformacion(true);
      axios
        .post(
          api.conexion + api.SISEVA.funcion.GetPersonas,
          peticion,
          comun.CrearElHeaderDeAutorizacion(
            store.state.Login_AutorizacionOriginal
          )
        )
        .then((response) => {
          if (response.data.SiHayError == false) {
            //En caso de recibir una respuesta exitosa
            this.infoPersonas = [];
            this.tipoEvaluadorBusqueda = [];
            var x = response.data.InfoPersonas.length;
            var i = 0;
            for (i = 0; i < x; i++) {
              this.tipoEvaluadorBusqueda.push(0);
            }
            this.infoPersonas = response.data.InfoPersonas;

            this.mostrarTabla = true;
            this.$nextTick(() => {
              PaginarTabla("tablaBusqueda", 10);
            });
          } else {
            console.error(response);
            comun.mensajeDeAlerta(response.data.Error.Mensaje, null, null);
            // this.error = response.data.Error.Mensaje;
            // $('#modalInvalidezAlerta').modal('show');
          }
          comun.SeEstaCargandoInformacion(false);
        })
        .catch((e) => {
          console.error("encontre un error " + e);
          comun.mensajeDeAlerta(
            comun.mensajeDeError(enumeraciones.error.E500),
            null,
            null
          );
        });
    },
    borrarFila: function (evaluador) {
      //Borra una fila de una tabla
      var i = 0;
      var numEvaluador = null;
      for (i = 0; i < this.nuevosEvaluadores.length; i++) {
        if (evaluador.PersonaId == this.nuevosEvaluadores[i].PersonaId) {
          numEvaluador = i;
        }
      }
      if (numEvaluador != null) {
        this.nuevosEvaluadores.splice(numEvaluador, numEvaluador + 1);
      }
      var indice = this.baneados.indexOf(evaluador.PersonaId); //Elimina a la persona borrada de la lista de excluidos de la busqueda de evaluadores

      this.$nextTick(() => {
        PaginarTabla("tablaEvaluadores", 3);
      });
      this.$delete(this.baneados, indice);
      this.cargarColaboradores();
      this.numeroFilas--;
    },

    agregarFila: function (event, infoPersona) {
      //Transfiere la información de la tabla de busqueda de evaluadores a la de evaluadores a asignar
      //console.log(infoPersona)
      var select =
        event.target.parentElement.parentElement.cells[4].childNodes[0];
      infoPersona.TipoEvaluador = select.value;
      //console.log(select.value)
      this.baneados.push(infoPersona.PersonaId);
      this.buscarEvaluadores();
      this.nuevosEvaluadores.push(infoPersona);
      //alert(event.target.parentElement.parentElement.childNodes[0].innerHTML);
      //alert(this.cuestionariosRequeridos[select.selectedIndex])
      //alert(select.selectedIndex)
      //this.cuestionariosRequeridos[select.selectedIndex] = true
      //alert(this.cuestionariosRequeridos[select.selectedIndex])
      this.$nextTick(() => {
        PaginarTabla("tablaEvaluadores", 3);
      });
      //Añade al posible evaluador a la lista de excluidos en la busqueda de evaluadores
      this.numeroFilas++;
    },
    agregarFilaInicio: function (infoPersona) {
      //Transfiere la información de la petición inicial a la tabla de evaluadores a asignar
      var fila = new Vue({
        //Crea un componente tr de vue que almacena la información y las acciones del evaluador agregado
        template:
          "<tr><td>" +
          infoPersona.EvaluadorId +
          "</td>" +
          "<td>" +
          infoPersona.NombreCompleto +
          "</td>" +
          "<td>" +
          infoPersona.Puesto +
          "</td>" +
          "<td>" +
          infoPersona.TipoEvaluador +
          "</td>" +
          "<td><i class='fa fa-trash' @click='borrarFila'/></td></tr>",
        methods: {
          borrarFila: this.borrarFila, //Carga los métodos requeridos
        },
      });
      fila.$mount();
      $("#tablaEvaluadores").find("tbody:last").append(fila.$el);
      this.$nextTick(() => {
        PaginarTabla("tablaEvaluadores", 3);
      });
      this.numeroFilas++; //Incrementa la cuenta de filas en la tabla de evaluadores a asignar
    },
    clickPestana: function (identificador) {
      //Simula el click sobre una pestaña
      $("#" + identificador).trigger("click");
    },
    cancelar: function () {
      //Limpia la tabla de evaluadores por asignar y recarga la información inicial de la vista
      Object.assign(this.$data, this.datosIniciales()); //Resetea los valores de las variables de vue
      $("#tablaEvaluadores > tbody").html(""); //Borra el contenido de la tabla de evaluadores
      this.cargarDatosEvaluacion(); //Recarga la información acerca de la evaluación
      this.clickPestana("general-tab"); //Redirige a la pestaña inicial de la vista
    },
    guardarEvaluadores: function () {
      //Guarda los evaluadores de la lista de evaluadores por asignar en la lista de evaluadores asignados
      var table = $("#tablaEvaluadores tbody");
      var id;
      var tipoEvaluador;
      var tipoEvaluadorId = 1;
      var evaluadores = [];
      var cuestionariosRequeridos = [true, false, false, false]; //Define el primer valor de cuestionariosRequeridos como true ya que representa la Autoevaluación, la cual siempre debe de cumplirse
      table.find("tr").each(function (rowIndex, r) {
        //Itera a través de la tabla de evaluadores por asignar
        id = parseInt(r.cells[0].innerHTML);
        tipoEvaluador = r.cells[3].innerHTML.trim(); //Extrae el id y el tipo de evaluación que hará el evaluador
        console.log(tipoEvaluador);
        if (tipoEvaluador == "Igual") {
          tipoEvaluadorId = 2;
        } else if (tipoEvaluador == "Superior") {
          tipoEvaluadorId = 3;
        }
        if (tipoEvaluador == "Subordinado") {
          tipoEvaluadorId = 4;
        } //Convierte el valor de tipoEvaluacion a un entero correspondiente
        evaluadores.push({ EvaluadorId: id, TipoEvaluador: tipoEvaluadorId }); //Añade la info del evaluador a la lista de evaluadores asignados
        cuestionariosRequeridos[tipoEvaluadorId - 1] = true; //Marca como requerido el tipo de evaluación que realizará el evaluador
      });
      this.evaluadores = evaluadores;
      this.evaluadoresAsignados = evaluadores.length;
      this.cuestionariosRequeridos = cuestionariosRequeridos;
      this.clickPestana("general-tab"); //Redirige a la pestaña principal de la vista
    },
    finalizar: function () {
      //Esta función guarda los evaluadores asignados dentro de la base de datos
      var evaluadoresPeticion = []; //Contiene la lista de evaluadores y el formato de cuestionario que realizará cada uno
      var idCuestionarios = this.idCuestionarios; //Almacena el id del cuestionario a realizar
      evaluadoresPeticion.push({
        EvaluadorId: this.evaluadoId,
        FormatoCuestionarioId: this.idCuestionarios[0],
      }); //Guarda la info del evaluado en la lista para sua autoevaluación
      this.evaluadores.forEach(function (evaluador) {
        //Itera a través de la lista de evaluadores asignados
        //Carga la información dentro de la lista para la petición
        evaluadoresPeticion.push({
          EvaluadorId: evaluador.EvaluadorId,
          FormatoCuestionarioId:
            idCuestionarios[parseInt(evaluador.TipoEvaluador) - 1],
        });
      });
      var peticion = {
        //Carga los datos requeridos para la peticion
        esPrueba: false,
        Evaluadores: evaluadoresPeticion,
        idEvaluacion: this.idEvaluacion,
      };
      axios
        .post(
          api.conexion + api.SISEVA.funcion.AsignarEvaluadores,
          peticion,
          comun.CrearElHeaderDeAutorizacion(
            store.state.Login_AutorizacionOriginal
          )
        )
        .then((response) => {
          if (response.data.SiHayError == false) {
            //En caso de una respuesta exitosa redidirige la página a /SISEVA/NuevaEvaluacion
            this.$parent.evaluaciones.splice(this.$parent.indiceEvaluacion, 1);
            this.$parent.pestana = 1;
          } else {
            console.error(response);
            comun.mensajeDeAlerta(response.data.Error.Mensaje, null, null);
          }
        })
        .catch((e) => {
          console.error("encontre un error " + e);
          comun.mensajeDeAlerta(
            comun.mensajeDeError(enumeraciones.error.E500),
            null,
            null
          );
        });
    },
    cargarColaboradores: function () {
      //Carga los valores para realizar la petición
      var peticion = {
        esPrueba: false,
        PersonaId: this.evaluadoId,
        //"PersonaId": 1498,
        Baneados: this.baneados,
        FechaInicial: this.fechaInicio,
        FechaFinal: this.fechaFin,
        PeriodoLaboralEvaluado: this.periodoLaboralEvaluado,
      };
      axios
        .post(api.conexion + api.SIAP.funcion.GetColaboradores, peticion)
        .then((response) => {
          if (response.data.SiHayError == false) {
            //En caso de recibir una respuesta exitosa
            var superiores = new Vue({
              //Genera un componente tbody de vue que contiene la información y acciones de los posibles evaluadores retornados
              template:
                "<select class='form-control' id='selectSuperiores'><option v-for='persona in Personas' v-bind:value='persona.PersonaId' v-bind:puesto='persona.Puesto' v-bind:seccion='persona.Seccion' v-bind:departamento='persona.Departamento' v-bind:nombre='persona.NombreCompleto'>{{persona.NombreCompleto}} - {{persona.Puesto}}</option></select>",
              data: {
                Personas: response.data.Superiores, //Carga los datos requeridos
              },
              methods: {},
            });
            superiores.$mount();
            $("#selectSuperioresDiv").empty();
            $("#selectSuperioresDiv").append(superiores.$el); //Borra el contenido de la tabla y agrega el componente recien creado
            var iguales = new Vue({
              //Genera un componente tbody de vue que contiene la información y acciones de los posibles evaluadores retornados
              template:
                "<select class='form-control' id='selectIguales'><option v-for='persona in Personas' v-bind:value='persona.PersonaId' v-bind:puesto='persona.Puesto' v-bind:seccion='persona.Seccion' v-bind:departamento='persona.Departamento' v-bind:nombre='persona.NombreCompleto'>{{persona.NombreCompleto}} - {{persona.Puesto}}</option></select>",
              data: {
                Personas: response.data.Iguales, //Carga los datos requeridos
              },
              methods: {},
            });
            iguales.$mount();
            $("#selectIgualesDiv").empty();
            $("#selectIgualesDiv").append(iguales.$el); //Borra el contenido de la tabla y agrega el componente recien creado
            var subordinados = new Vue({
              //Genera un componente tbody de vue que contiene la información y acciones de los posibles evaluadores retornados
              template:
                "<select class='form-control' id='selectSubordinados'><option v-for='persona in Personas' v-bind:value='persona.PersonaId' v-bind:puesto='persona.Puesto' v-bind:seccion='persona.Seccion' v-bind:departamento='persona.Departamento' v-bind:nombre='persona.NombreCompleto'> {{persona.NombreCompleto}} - {{persona.Puesto}}</option></select>",
              data: {
                Personas: response.data.Subordinados, //Carga los datos requeridos
              },
              methods: {},
            });
            subordinados.$mount();
            $("#selectSubordinadosDiv").empty();
            $("#selectSubordinadosDiv").append(subordinados.$el); //Borra el contenido de la tabla y agrega el componente recien creado
            this.obtenerEvaluadoresAnteriores();
          } else {
            console.error(response);
            comun.mensajeDeAlerta(response.data.Error.Mensaje, null, null);
            // this.error = response.data.Error.Mensaje;
            // $('#modalInvalidezAlerta').modal('show');
          }
        })
        .catch((e) => {
          console.error("encontre un error " + e);
          comun.mensajeDeAlerta(
            comun.mensajeDeError(enumeraciones.error.E500),
            null,
            null
          );
        });
    },
    obtenerEvaluadoresAnteriores: function () {
      //Carga los valores para realizar la petición
      var peticion = {
        esPrueba: false,
        HistorialLaboralId: this.periodoLaboralEvaluado,
        Fecha: this.fechaInicio,
        Baneados: this.baneados,
      };
      axios
        .post(
          api.conexion + api.SISEVA.funcion.ObtenerEvaluadoresAnteriores,
          peticion
        )
        .then((response) => {
          if (response.data.SiHayError == false) {
            //En caso de recibir una respuesta exitosa
            this.evaluadoresSuperioresAnteriores =
              response.data.EvaluadoresSuperioresAnteriores;
            this.evaluadoresIgualesAnteriores =
              response.data.EvaluadoresIgualesAnteriores;
            this.evaluadoresSubordinadosAnteriores =
              response.data.EvaluadoresSubordinadosAnteriores;
          } else {
            console.error(response);
            comun.mensajeDeAlerta(response.data.Error.Mensaje, null, null);
            // this.error = response.data.Error.Mensaje;
            // $('#modalInvalidezAlerta').modal('show');
          }
        })
        .catch((e) => {
          console.error("encontre un error " + e);
          comun.mensajeDeAlerta(
            comun.mensajeDeError(enumeraciones.error.E500),
            null,
            null
          );
        });
    },
    agregarEvaluador: function (tipoEvaluadorId) {
      let id = "";
      let tipoEvaluador = "";
      if (tipoEvaluadorId == 1) {
        id = "selectSuperiores";
        tipoEvaluador = "Superior";
      } else if (tipoEvaluadorId == 2) {
        id = "selectIguales";
        tipoEvaluador = "Igual";
      } else if (tipoEvaluadorId == 3) {
        id = "selectSubordinados";
        tipoEvaluador = "Subordinado";
      } else if (tipoEvaluadorId == 4) {
        id = "selectSuperioresPrevios";
        tipoEvaluador = "Superior";
      } else if (tipoEvaluadorId == 5) {
        id = "selectIgualesPrevios";
        tipoEvaluador = "Igual";
      } else if (tipoEvaluadorId == 6) {
        id = "selectSubordinadosPrevios";
        tipoEvaluador = "Subordinado";
      }
      const select = $("#" + id);
      const PersonaId = $("#" + id).val();
      const puesto = $("option:selected", select).attr("puesto");
      const nombre = $("option:selected", select).attr("nombre");
      const seccion = $("option:selected", select).attr("seccion");
      const departamento = $("option:selected", select).attr("departamento");
      //console.log(id)
      //console.log(nombre)
      //console.log(puesto)
      if(PersonaId){
      this.baneados.push(PersonaId);
      this.cargarColaboradores();
      const infoPersona = {
        PersonaId: PersonaId,
        NombreCompleto: nombre,
        Puesto: puesto,
        TipoEvaluador: tipoEvaluador,
        Seccion: seccion,
        Departamento: departamento,
      };
      this.nuevosEvaluadores.push(infoPersona);
      this.cuestionariosRequeridos[tipoEvaluadorId] = true;
      }
    },
    buscarEvaluadoresAsignados: function () {
      //Hace la petición para obtener a los evaluadores de la evaluación
      //Carga los valores requeridos para hacer la petición
      var peticion = {
        esPrueba: false,
        idEvaluacion: this.idEvaluacion,
      };
      axios
        .post(api.conexion + api.SISEVA.funcion.GetEvaluadores, peticion)
        .then((response) => {
          if (response.data.SiHayError == false) {
            //En caso de que la petición sea exitosa
            var filas = new Vue({
              //Crea un componente tbody de vue que contiene la información acerca de los evaluadores
              template:
                "<tbody class='text-dark'>" +
                "<tr v-for='evaluador in evaluadores'>" +
                "<td>{{ evaluador.Evaluador.PersonaId }}</td>" +
                "<td>{{evaluador.Evaluador.NombreCompleto}}</td>" +
                "<td>{{evaluador.Evaluador.Puesto}}</td>" +
                "<td>{{evaluador.TipoEvaluador}}</td>" +
                "<td>{{evaluador.EstatusEvaluacion}}</td>" +
                "<td  class='d-flex justify-content-around'>" +
                "<i class='fa fa-toggle-on' v-if='evaluador.Activo'/>" +
                "<i class='fa fa-toggle-off' v-if='!evaluador.Activo'/>" +
                "<i class='fa fa-info-circle'/>" +
                "</td>" +
                "</tr></tbody>",
              data: {
                evaluadores: response.data.evaluadores, //Carga los datos requeridos
              },
            });
            filas.$mount();
            $("#tablaEvaluadores2").find("tr:gt(0)").remove();
            $("#tablaEvaluadores2").append(filas.$el); //Borra todas las filas de la tabla y agrega las recien obtenidas
          } else {
            console.error(response);
            comun.mensajeDeAlerta(response.data.Error.Mensaje, null, null);
          }
        })
        .catch((e) => {
          console.error("encontre un error " + e);
          comun.mensajeDeAlerta(
            comun.mensajeDeError(enumeraciones.error.E500),
            null,
            null
          );
        });
    },
    RegresarLista: function () {
      this.$parent.pestana = 1;
    },
    cambioAreaHistorialLaboral(datos) {
      this.datosLocales[0].valor.Id = parseInt(datos.target.value);
      this.datosLocales[0].valor.Nombre =
        datos.target.options[datos.target.selectedIndex].text;
      

      // Reinicia la selección(valor) del componente de Departamento
      this.datosLocales[1].valor.Id = -1;
      this.datosLocales[1].valor.Nombre = "";
    },
    cambioTipoDepartamentoLaboral(datos) {
      this.datosLocales[1].valor.Id = parseInt(datos.target.value);
      this.datosLocales[1].valor.Nombre =
        datos.target.options[datos.target.selectedIndex].text;
    },
  },
  computed: {
    deshabilitarBoton: function () {
      //Indica si el boton de Finalizar está activo o no en base a los cuestionarios que se requerien definir y si ya están definidos
      return this.auto || this.superiores || this.iguales || this.subordinados;
    },
    auto: function () {
      return (
        /*this.cuestionariosRequeridos[0] == */ true &&
        this.idCuestionarios[0] == "0"
      );
    },
    superiores: function () {
      return this.cuestionariosRequeridos[2] && this.idCuestionarios[2] == "0";
    },
    iguales: function () {
      return this.cuestionariosRequeridos[1] && this.idCuestionarios[1] == "0";
    },
    subordinados: function () {
      return this.cuestionariosRequeridos[3] && this.idCuestionarios[3] == "0";
    },
  },
  mounted: function mounted() {
    //Carga la información de la evaluación y la lista de cuestionarios al principio
    this.cargarDatosEvaluacion();
    this.cargarCuestionarios();

    //$("#verEvaluadores").click(this.verEvaluadores);
  },
};
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/SISEVA/Evaluaciones/DetallesEvaluado.vue